import React, { useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import FileInputField from "../../ui/form/FileInputField";
import InputField from "../../ui/form/InputField";
import Button from "../../ui/utils/Button";
import Alert from "../../ui/utils/Alert";
import usePost from "../../../hooks/api/usePost";
import apiRequest from "../../../utils/vendor/apiRequest";

const EditGallery = ({ data, closeModal, callback }) => {
  const [preview, setPreview] = useState(null);

  const { error, isLoading, post, serverErrors } = usePost(
    apiRequest.updateGallery
  );

  const formik = useFormik({
    initialValues: {
      type: data?.type || "All",
      name: data?.name || "",
      file: "",
    },

    validationSchema: Yup.object({
      type: Yup.string().required(),
    }),

    onSubmit: async (values, { resetForm }) => {
      const formData = new FormData();
      formData.append("type", values.type);
      formData.append("name", values.name);
      if (values.file) formData.append("file", values.file);

      const response = await post({ data: { formData, id: data?._id } });
      if (response?.response) {
        callback();
        resetForm();
        closeModal();
      }
    },
  });

  return (
    <div>
      <h2 className="p-4 text-lg font-semibold">Edit Media</h2>
      <div className="border-b" />

      <form onSubmit={formik.handleSubmit} className="p-4 text-sm">
        {error && <Alert message={error} type="error" />}

        <InputField
          name="type"
          label="Type"
          value={formik.values.type}
          onChange={formik.handleChange}
        />

        <InputField
          name="name"
          label="Name"
          value={formik.values.name}
          onChange={formik.handleChange}
          serverError={serverErrors?.name}
        />

        <FileInputField
          id="file"
          label="Replace File (optional)"
          accept="image/*,video/*"
          onChange={(e) => {
            const file = e.currentTarget.files?.[0] || "";
            formik.setFieldValue("file", file);
            if (file) setPreview(URL.createObjectURL(file));
          }}
        />

        {preview && (
          <img src={preview} className="w-24 h-24 object-cover border rounded mt-2" />
        )}

        <div className="flex justify-end gap-2 mt-4">
          <Button variant="secondary" onClick={closeModal}>
            Cancel
          </Button>

          <Button variant="primary" isLoading={isLoading} loadingText="Updating...">
            Update
          </Button>
        </div>
      </form>
    </div>
  );
};

export default EditGallery;
